export enum EventType {
  Typing = 1,
  EndOfTyping = 2,
  LastMessageSeen = 3
}



// WEBPACK FOOTER //
// ./src/app/shared/signalR/models/events/event-type.ts